module.exports = __webpack_public_path__ + "static/media/sprites_2x.fc755f54.png";